import { TProductAggregatedState } from './types';

export function getProductAggregated(state: TProductAggregatedState) {
  return state.productAggregated;
}
